/**
 * User-specific localStorage helpers for draft storage.
 * Prevents cross-user data leakage by keying drafts to the current user's ID.
 */

export function getCurrentUserId() {
  try {
    const userData = JSON.parse(localStorage.getItem('shweebum_user') || '{}');
    return userData.id || '';
  } catch { return ''; }
}

export function getDraftKey(type) {
  const uid = getCurrentUserId();
  return uid ? `shweebum_${type}_drafts_${uid}` : `shweebum_${type}_drafts`;
}
